import { APP_PERMISSIONS } from '@exam-center/permission';
import { useHasPermission } from '@shared/permissions';

import { BlockedRecordFormDetails } from '../blocked-record-form-details';
import { BlockedRecordReadonlyDetails } from '../blocked-record-readonly-details';

export default function BlockedRecordDetails() {
  const hasUpdatePermission = useHasPermission(
    APP_PERMISSIONS.ADMIN_BLOCKLIST_MANAGEMENT.BLOCKED_USER.UPDATE,
  );

  if (hasUpdatePermission) {
    return <BlockedRecordFormDetails />;
  }

  return <BlockedRecordReadonlyDetails />;
}
